import { render, staticRenderFns } from "./SubscriptionPackageAdd.vue?vue&type=template&id=5a1cdf73&"
import script from "./SubscriptionPackageAdd.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPackageAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1cdf73')) {
      api.createRecord('5a1cdf73', component.options)
    } else {
      api.reload('5a1cdf73', component.options)
    }
    module.hot.accept("./SubscriptionPackageAdd.vue?vue&type=template&id=5a1cdf73&", function () {
      api.rerender('5a1cdf73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/subscriptionPackages/SubscriptionPackageAdd.vue"
export default component.exports